import type { ReactNode } from "react";

import "./LegacyBridgeTransitionPage.css";

type LegacyBridgeTransitionStatus = "loading" | "error";

type LegacyBridgeTransitionMetaItem = {
  label: string;
  value: string;
};

type Props = {
  ariaLabel?: string;
  className?: string;
  description: string;
  eyebrow: string;
  meta?: LegacyBridgeTransitionMetaItem[];
  role?: "alert" | "status";
  status?: LegacyBridgeTransitionStatus;
  title: string;
  actions?: ReactNode;
};

/** 旧系统跳转进入新系统时使用的统一过渡页。 */
export function LegacyBridgeTransitionPage({
  actions,
  ariaLabel,
  className,
  description,
  eyebrow,
  meta = [],
  role = "status",
  status = "loading",
  title,
}: Props) {
  const mergedClassName = [
    "legacy-bridge-transition-page",
    status === "error" ? "is-error" : "is-loading",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <main
      className={mergedClassName}
      aria-label={ariaLabel}
      role={role}
      aria-live={role === "status" ? "polite" : undefined}
    >
      <section className="legacy-bridge-transition-panel">
        <span className="legacy-bridge-transition-eyebrow">{eyebrow}</span>
        <h1>{title}</h1>
        <p>{description}</p>
        {meta.length > 0 ? (
          <dl>
            {meta.map((item) => (
              <div key={`${item.label}:${item.value}`}>
                <dt>{item.label}</dt>
                <dd>{item.value}</dd>
              </div>
            ))}
          </dl>
        ) : null}
        {actions ? <div className="legacy-bridge-transition-actions">{actions}</div> : null}
      </section>
    </main>
  );
}
